import axios from 'axios';
import axiosInstance from './AxiosService';

const companyService = {
  fetchCompanies: async () => {
    try {
      console.log("Fetching companies from API...");
      const response = await axiosInstance.get('companies/');
      console.log("Raw company response:", response);
      
      if (response && response.data) {
        console.log("Company data structure:", {
          type: typeof response.data,
          isArray: Array.isArray(response.data),
          length: Array.isArray(response.data) ? response.data.length : 'N/A',
          keys: typeof response.data === 'object' ? Object.keys(response.data) : 'N/A'
        });
        
        let companyData = response.data;
        
        // Check if the response contains a 'results' property (for paginated responses)
        if (!Array.isArray(companyData) && companyData.results && Array.isArray(companyData.results)) {
          console.log("Using paginated company results array");
          companyData = companyData.results;
        }
        
        // Ensure we have an array of companies
        if (!Array.isArray(companyData)) {
          console.warn("Company data is not an array, will convert to array:", companyData);
          if (typeof companyData === 'object') {
            companyData = [companyData];
          } else {
            companyData = [];
          }
        }
        
        console.log(`Processing ${companyData.length} companies from API`);
        
        // Check first item for debugging
        if (companyData.length > 0) {
          console.log("First company example:", companyData[0]);
          console.log("Company properties available:", Object.keys(companyData[0]));
        }
        
        return companyData;
      }
      
      return response.data;
    } catch (error) {
      console.error("Error in fetchCompanies:", error);
      return [];
    }
  },

  fetchCompanyById: async (companyId) => {
    const response = await axiosInstance.get(`companies/${companyId}/`);
    return response.data;
},

  createCompany: async (companyData) => {
    const response = await axiosInstance.post(`companies/`, companyData);
    return response.data;
  },

  updateCompany: async (companyId, companyData) => {
    const response = await axiosInstance.put(`companies/${companyId}/`, companyData);
    return response.data;
  },

  deleteCompany: async (companyId) => {
    const response = await axiosInstance.delete(`companies/${companyId}/`);
    return response.data;
  }
};

export default companyService;
